/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  ErrorResponse,
  ForgetPasswordRequest,
  ProjectResponseCollectionResponse,
  SendLinkConfirmAccountRequest,
  UserChangePasswordRequest,
  UserLoginRequest,
  UserResetPasswordRequest,
  UserResponseDataResponse,
  UserTokenValidationResponseDataResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';
export class Me<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Me
   * @name GetMe
   * @request GET:/Me
   * @response `200` `UserResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getMe = (params: RequestParams = {}) =>
    this.http.request<UserResponseDataResponse, ErrorResponse>({
      path: `/Me`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Me
   * @name ProjectsList
   * @request GET:/Me/Projects
   * @response `200` `ProjectResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  projectsList = (params: RequestParams = {}) =>
    this.http.request<ProjectResponseCollectionResponse, ErrorResponse>({
      path: `/Me/Projects`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Me
   * @name SendLinkConfirmAccountCreate
   * @request POST:/Me/SendLinkConfirmAccount
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  sendLinkConfirmAccountCreate = (
    data: SendLinkConfirmAccountRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Me/SendLinkConfirmAccount`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Me
   * @name ConfirmAccountCreate
   * @request POST:/Me/ConfirmAccount
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  confirmAccountCreate = (data: UserResetPasswordRequest, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Me/ConfirmAccount`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Me
   * @name SendLinkForgetPasswordCreate
   * @request POST:/Me/SendLinkForgetPassword
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  sendLinkForgetPasswordCreate = (data: ForgetPasswordRequest, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Me/SendLinkForgetPassword`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Me
   * @name ResetPasswordCreate
   * @request POST:/Me/ResetPassword
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  resetPasswordCreate = (data: UserResetPasswordRequest, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Me/ResetPassword`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Me
   * @name ValidateTokenCreate
   * @request POST:/Me/ValidateToken
   * @response `200` `UserTokenValidationResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  validateTokenCreate = (data: UserLoginRequest, params: RequestParams = {}) =>
    this.http.request<UserTokenValidationResponseDataResponse, ErrorResponse>({
      path: `/Me/ValidateToken`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Me
   * @name ChangePassword
   * @request POST:/Me/ChangePassword
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  changePassword = (data: UserChangePasswordRequest, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Me/ChangePassword`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
